/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Notificationservicehuburlclientid5Inputs */

const en_entity_notificationservicehuburlclientid5 = /** @type {(inputs: Entity_Notificationservicehuburlclientid5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notification Service Hub Client ID`)
};

const de_entity_notificationservicehuburlclientid5 = /** @type {(inputs: Entity_Notificationservicehuburlclientid5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungsservice Hub Client ID`)
};

/**
* | output |
* | --- |
* | "Notification Service Hub Client ID" |
*
* @param {Entity_Notificationservicehuburlclientid5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_notificationservicehuburlclientid5 = /** @type {((inputs?: Entity_Notificationservicehuburlclientid5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Notificationservicehuburlclientid5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_notificationservicehuburlclientid5(inputs)
	return de_entity_notificationservicehuburlclientid5(inputs)
});
export { entity_notificationservicehuburlclientid5 as "entity_notificationServiceHubUrlClientId" }